<template>
    <!-- swiper -->
    <div class="swiper-box">
        <div class="title">商户实证</div>
        <div class="tips">你的成功是我们的成就</div>
        <div class="mySwiper">
            <img src="@/assets/images/prev.png" @click="check('prev')" alt="" class="prev">
            <img src="@/assets/images/next.png" @click="check('next')" alt="" class="next">
            <template v-if="caseList.length">
                <!-- <swiper class="mySwiper-box" ref="mySwiper"
                    :options="this.isMobile() ? mobileSwiperOptions : pcSwiperOptions">
                    <swiper-slide v-for="(item, index) in caseList" :key="index" class="swiper-item flex-bt">
                        <div class="left">
                            <img :src="item.bigimg" alt="">
                        </div>
                        <div class="right">
                            <div class="logo">
                                <img :src="item.smallimg" alt="">
                            </div>
                            <div class="content">{{ item.content }}</div>
                            <div class="bottom flex-bt">
                                <span>{{ item.title }}</span>
                                <router-link to="/register">
                                    <div class="start">免费试用开店</div>
                                </router-link>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper> -->
                <div class="swiper-container mySwiper-box" ref="mySwiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide swiper-item flex-bt" v-for="(item, index) in caseList" :key="index">
                            <div class="left">
                                <img :src="item.bigimg" alt="">
                            </div>
                            <div class="right">
                                <div class="logo">
                                    <img :src="item.smallimg" alt="">
                                </div>
                                <div class="content">{{ item.content }}</div>
                                <div class="bottom flex-bt">
                                    <span>{{ item.title }}</span>
                                    <router-link to="/register">
                                        <div class="start">免费试用开店</div>
                                    </router-link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </template>

        </div>
    </div>
</template>
<script>
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

// import 'swiper/css/swiper.css'
export default {
    // components: {
    //     Swiper,
    //     SwiperSlide
    // },
    data() {
        return {
            witdh: 0,
            caseList: [],
            showSwiper: false,
            swiper: null,
            pcSwiperOptions: {
                loop: true,
                width: window.innerWidth,
                speed: 1200,
                spaceBetween: 136,
                slidesPerView: "auto",
                centeredSlides: true,
                observer: true,
            },
            mobileSwiperOptions: {
                speed: 1200,
                init: true,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                loop: true,
                spaceBetween: 20,
                slidesPerView: "1",
                centeredSlides: true,
            }
        }
    },

    computed: {

    },

    methods: {
        isMobile() {
            let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            return flag;
        },

        check(val) {
            this.swiper.update()
            val === 'prev' && this.swiper.slidePrev()
            val === 'next' && this.swiper.slideNext()
        },
        async getCaseList() {
            this.showSwiper = false
            let fdata = { do: 'json', sjk: 'caselist', orderby: 'orderid asc' }
            let res = await this.$api.funk(fdata)
            this.caseList = [...res]
            this.witdh = window.innerWidth
            const _this = this
            await this.sleep(500)
            if (this.isMobile()) {
                this.swiper = new this.$Swiper('.mySwiper-box', {
                    speed: 1200,
                    init: true,
                    autoplay: {
                        delay: 5000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    loop: true,
                    spaceBetween: 20,
                    slidesPerView: "1",
                    centeredSlides: true,
                })
            } else {
                this.swiper = new this.$Swiper('.mySwiper-box', {
                    loop: true,
                    width: window.innerWidth,
                    speed: 1200,
                    autoplay: {
                        delay: 5000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    spaceBetween: 136,
                    slidesPerView: "auto",
                    centeredSlides: true,
                    observer: true,
                })
            }
            await this.sleep(500)
            this.showSwiper = true

        },

        sleep(time) {
            return new Promise((resolve) => setTimeout(resolve, time))
        },

        async updateSwiper() {
            await this.sleep(500)
            this.swiper.update()
        },

    },

    watch: {
        'witdh': function () {
            if (this.swiper) {
                this.updateSwiper()
            }
        }
    },

    created() {
        this.witdh = window.innerWidth
    },

    mounted() {
        this.getCaseList()
        const _this = this
        window.onresize = () => {
            return (() => {
                _this.witdh = window.innerWidth
            })()
        }
    }
}
</script>
<style lang="scss" scoped>
.swiper-box {
    background: rgba(224, 46, 67, 0.1);
    padding-top: 0.38rem;
    padding-bottom: 1.28rem;
    width: 100%;

    .mySwiper {
        margin-top: 0.42rem;
        position: relative;
        width: 100%;

        .mySwiper-box {
            position: relative;
            width: 100%;
        }
    }

    .prev {
        width: 0.36rem;
        height: 0.63rem;
        display: block;
        position: absolute;
        top: 0;
        left: 0.48rem;
        bottom: 0;
        margin: auto 0;
        z-index: 99;
        cursor: pointer;
    }

    .next {
        width: 0.36rem;
        height: 0.63rem;
        display: block;
        position: absolute;
        top: 0;
        right: 0.48rem;
        bottom: 0;
        margin: auto 0;
        z-index: 99;
        cursor: pointer;
    }

    .title {
        font-family: 'Microsoft YaHei';
        font-style: normal;
        font-weight: 600;
        font-size: 0.48rem;
        line-height: 0.68rem;
        color: #000000;
        text-align: center;
    }

    .tips {
        margin-top: 0.04rem;
        font-family: 'Microsoft YaHei';
        font-style: normal;
        font-weight: 400;
        font-size: 0.24rem;
        line-height: 0.34rem;
        text-align: center;
        color: #000000;
    }

    .swiper-item {
        width: 12.8rem;
        height: 4.48rem;
        background: #ffffff;
        margin: 0;
        border-radius: 0.16rem;
        overflow: hidden;

        .left {
            height: 100%;
            width: 6.3rem;

            img {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
            }
        }

        .right {
            flex: 1;
            padding: 0.4rem;
            height: 100%;

            .bottom {
                align-items: flex-end;

                span {
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 0.2rem;
                    line-height: 0.2rem;
                    color: #000000;
                }

                .start {
                    width: 2.24rem;
                    height: 0.64rem;
                    background: #E02E43;
                    border-radius: 0.08rem;
                    text-align: center;
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 0.24rem;
                    line-height: 0.64rem;
                    color: #FFFFFF;
                    cursor: pointer;
                }
            }

            .logo {
                width: 1.5rem;
                height: 0.7rem;

                img {
                    display: block;
                    object-fit: contain;
                }
            }

            .content {
                width: 5.3rem;
                height: 1.96rem;
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 0.34rem;
                color: #000000;
                margin-top: 0.24rem;

            }
        }
    }
}

@media (max-width: 750px) {
    .swiper-box .swiper-item {
        width: 6rem;
        display: block;
        height: auto;
    }

    .swiper-box .swiper-item .left {
        width: 100%;
        height: 5.08rem;
    }

    .swiper-box .next {
        right: 0.1rem;
    }

    .swiper-box .prev {
        left: 0.1rem;
    }

    .swiper-box .swiper-item .right {
        height: auto;
        padding: 0.4rem 0.2rem;
    }

    .swiper-box .swiper-item .right .content {
        font-size: 0.28rem;
        line-height: 0.34rem;
    }

    .swiper-box .swiper-item .right .bottom span {
        font-size: 0.26rem;
        line-height: 0.26rem;
    }

    .swiper-box .mySwiper {
        padding: 0 0.6rem;
    }
}
</style>